import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "modal-footer" }

import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPopup',
  props: {
  visible: Boolean,
  css:String
},
  setup(__props) {

const props = __props

//onMounted(()=>console.log(props.css))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (__props.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-container", props.css])
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("i", {
                    class: "bi-x-lg right",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }),
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _createTextVNode("default header")
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "body")
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "footer")
                ])
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})